import { createI18n } from 'vue-i18n'
import zhCN from './lang/zh-CN'
import enUS from './lang/en-US'

const i18n = createI18n({
  legacy: true, // 兼容 Options API
  locale: sessionStorage.getItem('language') || 'zh-CN', // 默认语言，使用sessionStorage实现弱缓存
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS
  }
})

export default i18n